import { render, staticRenderFns } from "./AvatarVsAvatar.vue?vue&type=template&id=2b1fce76&scoped=true&"
import script from "./AvatarVsAvatar.vue?vue&type=script&lang=js&"
export * from "./AvatarVsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AvatarVsAvatar.vue?vue&type=style&index=0&id=2b1fce76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fce76",
  null
  
)

export default component.exports